import { TFunction } from 'i18next'

import { NotificationKeys } from '../../../enums/notificationKeys'
import { InvoiceDocumentType } from '../enums/invoiceDocumentType'
import { InvoiceStatus } from '../enums/invoiceStatus'
import { isDocumentTypeCreditNote } from './isDocumentTypeCreditNote'

interface ManualDeliveryStatusNotification {
  id: NotificationKeys
  successMessage: string
  errorMessage: string
}

export const getManualDeliveryStatusNotification = (
  targetStatus: InvoiceStatus.Sent | InvoiceStatus.Unsent,
  documentType: InvoiceDocumentType,
  t: TFunction,
): ManualDeliveryStatusNotification => {
  const isCreditNote = isDocumentTypeCreditNote(documentType)

  if (targetStatus === InvoiceStatus.Unsent) {
    return {
      id: NotificationKeys.ExternalInvoiceUnmarkedAsSent,
      successMessage: isCreditNote
        ? t('external_invoices.credit_note_unmarked_as_sent')
        : t('external_invoices.invoice_unmarked_as_sent'),
      errorMessage: t('error_unmarking_as_sent'),
    }
  }

  return {
    id: NotificationKeys.ExternalInvoiceMarkedAsSent,
    successMessage: isCreditNote
      ? t('external_invoices.credit_note_marked_as_sent')
      : t('external_invoices.invoice_marked_as_sent'),
    errorMessage: t('error_marking_as_sent'),
  }
}
